import React, { Fragment, useEffect, useContext } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import errorHandler from "../../../hoc/ErrorHandler";
import context from "../../../context/auth-context";
import Aside from "./Aside/Aside";
// import Calendar from './Calendar/eBoardCalendar';
import withClass from "../../../hoc/withClass";
import { DEV_ENVIRONMENT } from "../../../constants";
import CustomCalendar from "./Calendar/CustomCalendar";

const Dashboard = (props) => {
  document.body.className = "page-aside-left";
  const [filter, setFilter] = React.useState(null);

  const authContext = useContext(context);
  useEffect(() => {
    // sessionStorage.removeItem("username");
    // sessionStorage.removeItem("code");

    localStorage.removeItem("username");
    localStorage.removeItem("code");
  }, []);

  useEffect(() => {
    if (!authContext.authenticated){
      window.location.assign(
          process.env.REACT_APP_HOMEPAGE
      );
      }

    if (process.env.REACT_APP_DEV_ENVIRONMENT  !== "localhost" && !props.geoInfo)
      (async () =>
        await fetch("https://ipapi.co/json")
          .then((response) => response.json())
          .then((data) => props.onSetGeoInfo(data)))();

    if (!props.timeZones)
      (async () => {
        const timeZones = await axios.get("/utilities/timezones");
        if (timeZones) props.onSetTimeZones(timeZones.data);
      })();

    return () =>
      document.body.className.replace(/\bapp-calendar page-aside-left\b/g, "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authContext.authenticated]);

  return (
    <Fragment>
      <Aside setFilter={setFilter} />
      {/* <Calendar /> */}
      <CustomCalendar filter={filter} />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    geoInfo: state.utilities.geoInfo,
    timeZones: state.utilities.timeZones,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetGeoInfo: (info) => dispatch({ type: "SET_GEO_INFO", payload: info }),
    onSetTimeZones: (timeZones) =>
      dispatch({ type: "SET_TIME_ZONES", payload: timeZones }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(errorHandler(withClass(Dashboard, "page bg-white"), axios)));
